module.exports = __webpack_public_path__ + "static/img/unionpay.72bdb77b.png";